import React from 'react';
import { inIframe } from '../../utils/location';
import { Overlay } from '../Overlay';
import type { GalleryImage } from './ImageGallery';
import { ImageGallery } from './ImageGallery';

interface ImageGalleryPopupProps<T extends GalleryImage> {
  opened: boolean;
  images: T[];
  startImageIndex?: number;
  onClose: VoidFunction;
  onImageVisible?: (image: T) => void;
}

export const ImageGalleryPopup = <T extends GalleryImage>({
  images,
  opened,
  onClose,
  startImageIndex,
  onImageVisible,
}: ImageGalleryPopupProps<T>) => {
  const isIframe = inIframe();

  return (
    <Overlay opened={opened} onClose={onClose}>
      <ImageGallery
        images={images}
        startImageIndex={startImageIndex}
        onClose={onClose}
        disableZoom={isIframe}
        onImageVisible={onImageVisible}
      />
    </Overlay>
  );
};
